const excludedRequests = ['/quizzes/history', '/user/profile'];

export { excludedRequests };
